export const BACK_TO_TOP_BUTTON_PREFIX = "BackToTopButton";

export const BACK_TO_TOP_BUTTON_CLASSES = {
  isVisible: `${BACK_TO_TOP_BUTTON_PREFIX}-isVisible`,
  isHidden: `${BACK_TO_TOP_BUTTON_PREFIX}-isHidden`,
  up: `${BACK_TO_TOP_BUTTON_PREFIX}-up`,
  caption: `${BACK_TO_TOP_BUTTON_PREFIX}-caption`,
};
